<template>
  <div :data-v="'v-1.1.0'">
    <banners-module v-if="name === 'BannersModule'" />
    <google-avis-panel v-if="name.includes('avis')" :name="name" />
    <header-funnel-module
      v-if="name === 'HeaderFunnelModule'"
      :type="Number(typeParcours)"
    />
    <header-module v-if="name === 'HeaderModule'" />
    <footer-panel v-if="name === 'FooterModule'" :organisation="organisation" />
    <recherche-module
      v-if="name === 'rechercheModule'"
      :type="type"
      :hp-type="hpType"
      :display-title="displayTitle"
    />
    <makes-module v-if="name === 'makeHp'" />
    <licence-plate v-if="name === 'licencePlate'" :title="title" />
  </div>
</template>

<script>
import HeaderModule from "../../../components/modules/layouts/HeaderModule";
import HeaderFunnelModule from "../../../components/modules/layouts/HeaderFunnelModule";
import FooterPanel from "../../../components/panels/layouts/FooterPanel";
import rechercheModule from "../../../components/modules/commons/rechercheModule";
import licencePlate from "../../../components/modules/commons/licencePlateModule";
import makesModule from "../../../components/modules/commons/MakesModule";
import googleAvisPanel from "../../../components/panels/avis/googleAvisPanel";
import stores from "../../../store/header";
import Vue from "vue";
import { BootstrapVue, IconsPlugin } from "../../../node_modules/bootstrap-vue";

// Import Bootstrap and BootstrapVue CSS files (order is important)
import "../../../node_modules/bootstrap/dist/css/bootstrap.css";
import "../../../node_modules/bootstrap-vue/dist/bootstrap-vue.css";
import BannersModule from "../../../components/modules/banners/bannersModule.vue";

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

require("dotenv").config();

export default {
  name: "VueClownComponent",
  components: {
    BannersModule,
    FooterPanel,
    HeaderModule,
    rechercheModule,
    HeaderFunnelModule,
    makesModule,
    licencePlate,
    googleAvisPanel,
  },
  props: {
    name: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "Estimer gratuitement ma voiture",
    },
    type: {
      type: String,
      default: "",
    },
    typeParcours: {
      type: [Number, String],
      default: () => 1,
    },
    displayTitle: {
      type: Boolean,
      required: false,
      default: true,
    },
    organisation: {
      type: String,
      default: "",
    },
    hpType: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      stores,
      storage: null,
    };
  },
};
</script>

<style lang="scss">
@import "~bootstrap/scss/bootstrap";
@import "../../../node_modules/bootstrap/scss/_variables.scss";
@import "../../../node_modules/bootstrap/scss/_functions.scss";
@import "../../../node_modules/bootstrap/scss/_mixins.scss";
@import "../../../assets/sass/base/carizy/base.scss";
</style>
